/**
 * Acabamento premium compartilhado pelos cartões de dashboard.
 * Mantém profundidade, movimento e foco consistentes entre módulos.
 *
 * RELEASE: 2026-10-03 v1.0.0 - Extraído do Dashboard de Veículos para reuso.
 */
export const PREMIUM_DASHBOARD_CARD =
  'border-border/50 bg-card shadow-lg transition-all duration-300 ease-out hover:shadow-xl hover:shadow-primary/5 motion-safe:sm:hover:-translate-y-0.5';

/** Variante externa compacta: compõe o CRM e mantém sombras temáticas e movimento acessível. */
export const PROVIDER_DASHBOARD_CARD =
  `${PREMIUM_DASHBOARD_CARD} rounded-lg [box-shadow:var(--portal-shadow)] hover:[box-shadow:var(--portal-shadow-hover)] motion-reduce:transition-none motion-reduce:transform-none`;